module.exports = __webpack_public_path__ + "img/hard-hat.ec318e28.svg";